import React from "react";
import { View, StyleSheet } from "react-native";

// Plain-View 2x2 grid glyph for the free-rack chips (spec p2 frame 3) —
// no dedicated grid/rack SVG asset exists in @assets/svg, so this avoids
// adding one just for four little squares.

const GridIcon = ({ size = 10, color, style }) => (
  <View
    style={[styles.grid, { width: size * 2 + 2, height: size * 2 + 2 }, style]}
  >
    {[0, 1, 2, 3].map((i) => (
      <View
        key={i}
        style={[
          styles.cell,
          { width: size, height: size, backgroundColor: color },
        ]}
      />
    ))}
  </View>
);

export default GridIcon;

const styles = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignContent: "space-between",
  },
  cell: { borderRadius: 1.5 },
});
